
import { Container, Typography, Stack, Button } from "@mui/material";
import BannersGrid from "../grid";
import Iconify from "src/components/iconify";
import { useRouter } from "src/routes/hooks";
import { useGetBannersQuery } from "src/context/api/onboard/api";
import { paths } from "src/routes/paths";

export default function Banners() {
    const router = useRouter();
    const { data: banners, isLoading, isError, refetch } = useGetBannersQuery();
    return (
        <Container maxWidth="xl">   
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h5">Banners</Typography>
                <Button onClick={() => router.push(paths.admin.onboard.banners.add)} variant="contained" size="medium" color="primary">
                    <Iconify icon="mdi:plus" />
                    Add Banner
                </Button>
            </Stack>
            <BannersGrid banners={banners || []} edit={true} />
        </Container>
    )
}